/**
 * 統計カードコンポーネント
 *
 * ダッシュボードで使用する統計表示カード
 */

import { Link } from 'react-router-dom';

function StatsCard({
  title,
  value,
  max,
  unit = '',
  icon,
  color = 'blue',
  showUpgradeButton = false,
  showRewardButton = false
}) {
  // 進捗率を計算
  const progress = max ? Math.min((value / max) * 100, 100) : 0;
  const isNearLimit = max && progress >= 80;

  // カラー設定
  const colors = {
    blue: {
      bg: 'bg-blue-50',
      text: 'text-blue-600',
      bar: 'bg-blue-500',
      barBg: 'bg-blue-100'
    },
    purple: {
      bg: 'bg-purple-50',
      text: 'text-purple-600',
      bar: 'bg-purple-500',
      barBg: 'bg-purple-100'
    },
    gold: {
      bg: 'bg-yellow-50',
      text: 'text-yellow-600',
      bar: 'bg-yellow-500',
      barBg: 'bg-yellow-100'
    },
    gray: {
      bg: 'bg-gray-50',
      text: 'text-gray-600',
      bar: 'bg-gray-500',
      barBg: 'bg-gray-100'
    },
    primary: {
      bg: 'bg-primary/10',
      text: 'text-primary',
      bar: 'bg-primary',
      barBg: 'bg-primary/20'
    }
  };

  const colorSet = colors[color] || colors.blue;

  return (
    <div className="card">
      <div className="flex items-start justify-between mb-3">
        <div>
          <p className="text-sm text-gray-500">{title}</p>
          <div className="flex items-baseline gap-1 mt-1">
            <span className="text-2xl font-bold text-gray-900">{value}</span>
            {max && (
              <span className="text-sm text-gray-400">/ {max.toLocaleString()}</span>
            )}
            {unit && !max && (
              <span className="text-sm text-gray-500">{unit}</span>
            )}
          </div>
        </div>
        <div className={`w-10 h-10 ${colorSet.bg} rounded-xl flex items-center justify-center text-xl`}>
          {icon}
        </div>
      </div>

      {/* プログレスバー */}
      {max && (
        <div className="mt-3">
          <div className={`h-2 ${colorSet.barBg} rounded-full overflow-hidden`}>
            <div
              className={`h-full ${colorSet.bar} rounded-full transition-all duration-500`}
              style={{ width: `${progress}%` }}
            />
          </div>
          {isNearLimit && (
            <p className="text-xs text-orange-500 mt-1">
              残り{max - value}{unit.includes('/') ? unit.split('/')[0] : unit}
            </p>
          )}
        </div>
      )}

      {/* アップグレードボタン */}
      {showUpgradeButton && (
        <Link
          to="/subscription"
          className="mt-3 block w-full text-center py-2 text-sm font-medium text-primary bg-primary/10 rounded-lg hover:bg-primary/20 transition-colors"
        >
          アップグレード
        </Link>
      )}

      {/* リワード広告ボタン */}
      {showRewardButton && (
        <button
          className="mt-3 w-full py-2 text-sm font-medium text-green-600 bg-green-50 rounded-lg hover:bg-green-100 transition-colors"
          onClick={() => {
            // リワード広告の処理（将来実装）
            console.log('リワード広告を表示');
          }}
        >
          広告を見て +3 回
        </button>
      )}
    </div>
  );
}

export default StatsCard;
